import React from "react"

const Buttons = props => (
  <div className={`buttons ${props.className}`}>{props.children}</div>
)

export default Buttons
